import { useCallback, useEffect, useState } from "react";
import {
  Categories,
  ContentItem,
} from "#/api/partnersShowcase/partnersShowcase";
import { useGetCategoryPartnerActive } from "#/requests/get-category-partner-active";
import { useGetCategories } from "#/requests/get-categories";

export const useSystemicCategories = () => {
  const [sCategories, setSCategories] = useState<Categories[] | undefined>(
    undefined
  );
  const activeCategory = useGetCategoryPartnerActive({});
  const categories = useGetCategories({});

  const removeDuplicates = useCallback(async (auxCategories) => {
    const unique: Categories[] = auxCategories.reduce(
      (previous: Categories[], current: Categories) => {
        const object = previous.filter(
          (objects: Categories) => objects?.id === current?.id
        );
        if (object.length === 0) {
          previous.push(current);
        }
        return previous;
      },
      []
    );
    return unique;
  }, []);

  useEffect(() => {
    let auxCategories: Categories[] = [];
    if (
      activeCategory.data &&
      categories.data &&
      activeCategory?.data?.content
    ) {
      activeCategory?.data?.content?.forEach((item: ContentItem) => {
        const category = item.category;
        auxCategories.push({
          id: category?.id ?? null,
          name: category?.name ?? "Sem categoria",
          sequence: category?.sequence,
        } as Categories);
      });
      removeDuplicates(auxCategories).then((unique: Categories[]) => {
        const auxUnique: Categories[] | undefined = unique?.map((elem) => {
          return categories.data.find((elemP) => elemP?.id === elem?.id);
        });

        setSCategories(auxUnique);
      });
    }
  }, [activeCategory.data, categories.data, removeDuplicates]);

  return sCategories;
};
